export const getBundleType = () => {
  try {
    if (import.meta.env.LEGACY) return 'legacy';
    return 'modern';
  } catch (e) {
    return 'unknown';
  }
};
